import React from 'react';
import PropTypes from 'prop-types';

export default class Posts extends React.Component { 
  render() { 
    return ( 
      <ul>
      {this.props.posts.map((post, i) => <li key={i}><a href={post.url} target="_blank">{post.title}</a></li>)} 
      </ul>
    ) 
  }
}

Posts.propTypes = { 
  posts: PropTypes.array.isRequired
}




// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/subreddit/Posts.js